import BlogTable from "@/components/blog/BlogTable";

export default function Blog() {
    return (
        <div className="flex items-center h-full pt-10 flex-col">
            <BlogTable/>
        </div>
    );
}
